export const setDoctorsRedux = doctors => ({
  type: 'SET_DOCTORS',
  payload: doctors,
});

export const clearDoctors = () => ({
  type: 'CLEAR_DOCTORS',
});
